import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { FilterDTO, PagedResultDTOOfPaymentReportDTO, PaymentReportClient, PaymentReportParameterDTO, SavedReportFileDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ErrorType } from 'src/app/core/routing/error-types';
import { SaveOptions } from '../../reports-footer/save-options';

@Injectable()
export class PaymentReportService extends ShowInactiveService implements IAdaptorService {
  public parameters: PaymentReportParameterDTO = new PaymentReportParameterDTO();

  constructor(private paymentReportClient: PaymentReportClient,
              private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfPaymentReportDTO> {
    if (!this.parameters.dateRange.startDate || !this.parameters.dateRange.endDate) {
      return of(new PagedResultDTOOfPaymentReportDTO());
    }
    return this.paymentReportClient.searchPaymentReportData(this.parameters, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(paymentReportParameterDTO: PaymentReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.paymentReportClient.exportPaymentReport(
      saveOptions.saveReport,
      paymentReportParameterDTO
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
